<div
  class="campaign std-ta-center nx-margin-top-l nx-hidden-m nx-hidden-xs nx-hidden-s nx-hidden-m-horizontal"
>
  <div class="club_member">
    <div class="club_icon nx-margin-x-2m">
      <img src="assets/images/shared/campaign/club-icon.svg" />
      <p class="club_title">{{ clubData.campaignName }}</p>
    </div>
    @if (clubData.hasError) {
      <div nxRow rowJustify="center">
        <p class="empty-campaign-text">
          The Campaign is unavailable. Please contact your servicing branch
        </p>
      </div>
    }
    @if (!clubData.hasError) {
      <div class="badge_container nx-margin-y-2m">
        <div class="ranks_container customized-stepper">
          <app-custom-stepper
            #stepper1
            [dataList]="tempCampaignRankData"
            class="stepper"
          ></app-custom-stepper>
        </div>
      </div>
      <nx-card class="campaign_boxes">
        <div nxLayout="grid nopadding" class="std-ta-left">
          @if (clubData.isCompleted) {
            <div nxRow rowAlignItems="center">
              <div nxCol="12">
                <nx-card class="criteria_box">
                  <div nxLayout="grid">
                    <div nxRow>
                      <div nxCol="12" class="justify_content_center">
                        <!-- <img src="assets/images/shared/campaign/royal-eagle.svg"
                        class="success_icon"> -->
                        <img
                          [src]="
                            'data:' +
                            getImageType(clubData.currentRank?.badgeFilename) +
                            ';base64,' +
                            clubData.currentRank?.badgeBase64
                          "
                          class="success_icon"
                        />
                      </div>
                      <div nxCol="12" class="std-mg-top-2m">
                        <h3 nxHeadline="subsection-large" class="std-ta-center">
                          {{ getCongratulatoryMessage(clubData) }}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div nxRow class="std-mg-top-2m">
                    <div nxCol="12" class="reward_box">
                      <div>
                        <nx-badge class="rewards">
                          <nx-icon
                            name="check"
                            size="s"
                            class="nx-margin-right-2xs"
                          ></nx-icon
                          >Unlocked
                        </nx-badge>
                      </div>
                      <h4
                        nxHeadline="subsection-xsmall"
                        class="nx-font-weight-bold"
                      >
                        &nbsp; {{ clubData.currentRank?.rewards }}
                      </h4>
                    </div>
                  </div>
                </nx-card>
              </div>
            </div>
          }
          @if (!clubData.isCompleted) {
            <div nxRow>
              <div nxCol="12" class="justify_content_left">
                <div style="margin-right: 16px">
                  @if (clubData.currentRank) {
                    <img
                      [src]="
                        'data:' +
                        getImageType(clubData.currentRank.badgeFilename) +
                        ';base64,' +
                        clubData.currentRank.badgeBase64
                      "
                      class="big_badge"
                    />
                  }
                </div>
                @if (clubData.currentRank) {
                  <div style="width: 100%">
                    <div
                      class="justify_content_left"
                      style="align-items: baseline"
                    >
                      <h4
                        nxHeadline="subsection-xsmall"
                        class="nx-font-weight-bold nx-margin-0"
                      >
                        Current Status
                      </h4>
                      &nbsp; &nbsp;
                      <h4 nxHeadline="subsection-small" class="primary_blue">
                        <b>{{ clubData.currentRank?.name }}</b>
                      </h4>
                    </div>
                    <p
                      nxCopytext="normal"
                      class="grey"
                      style="margin-top: 6px !important"
                    >
                      {{ formatDate(clubData?.startDate, "DD/MM/YYYY") }} -
                      {{ formatDate(clubData?.endDate, "DD/MM/YYYY") }}
                    </p>
                    <div class="justify_content_between std-mg-top-s">
                      <p nxCopytext="normal" class="grey">
                        {{ clubData.currentRank?.name }}
                      </p>
                      <p nxCopytext="normal" class="grey break_word">
                        {{ clubData.nextRank?.name }}
                      </p>
                    </div>
                    <nx-progressbar
                      [value]="
                        calculateRankPercentage(
                          clubData.currentRank?.progressPercentage
                        )
                      "
                      class="nx-margin-top-3xs"
                    ></nx-progressbar>
                  </div>
                }
              </div>
              @if (!clubData.currentRank) {
                <div nxCol="12">
                  <p nxCopytext="normal" class="grey">
                    {{ formatDate(clubData?.startDate, "DD/MM/YYYY") }} -
                    {{ formatDate(clubData?.endDate, "DD/MM/YYYY") }}
                  </p>
                  <div class="justify_content_between std-mg-top-s">
                    <p nxCopytext="normal" class="grey">
                      {{ clubData.currentRank?.name }}
                    </p>
                    <p nxCopytext="normal" class="grey break_word">
                      {{ clubData.nextRank?.name }}
                    </p>
                  </div>
                  <nx-progressbar
                    [value]="
                      calculateRankPercentage(
                        clubData.nextRank?.progressPercentage
                      )
                    "
                    class="nx-margin-top-3xs"
                  ></nx-progressbar>
                </div>
              }
            </div>
            <div nxRow rowAlignItems="center" class="std-mg-top-2m">
              <div nxCol="12">
                <nx-card class="criteria_box">
                  <div class="justify_content_between">
                    <div
                      class="justify_content_left"
                      style="align-items: baseline"
                    >
                      <h4 nxHeadline="subsection-xsmall" class="no_white_space">
                        <b>Next Status &nbsp;</b>
                      </h4>
                      <h4
                        nxHeadline="subsection-small"
                        class="nx-font-weight-bold primary_blue break_word"
                      >
                        <b>{{ clubData.nextRank?.name }}</b>
                      </h4>
                    </div>
                    @if (clubData.nextRank?.info) {
                      <div class="justify_content_center grey">
                        <p
                          nxCopytext="normal"
                          (click)="openFromTemplate()"
                          class="no_white_space"
                        >
                          More Info
                        </p>
                        <nx-icon name="chevron-right" size="s"></nx-icon>
                      </div>
                    }
                    <ng-template #template>
                      <div class="std-ta-center campaign">
                        <img
                          [src]="
                            'data:' +
                            getImageType(clubData.nextRank.badgeFilename) +
                            ';base64,' +
                            clubData.nextRank.badgeBase64
                          "
                          class="big_badge"
                        />
                        <h3
                          nxHeadline="subsection-medium"
                          class="nx-margin-top-m"
                        >
                          {{ clubData.nextRank.name }}
                        </h3>
                        <p
                          nxCopytext
                          class="nx-margin-top-m nx-font-weight-light"
                        >
                          {{ clubData.nextRank.info }}
                        </p>
                      </div>
                      <div class="std-ta-center">
                        <button
                          nxModalClose
                          nxButton="secondary"
                          (click)="closeTemplateDialog()"
                          class="std-mg-top-2m"
                        >
                          CLOSE
                        </button>
                      </div>
                    </ng-template>
                  </div>
                  <!--------------------CHANGE CODE ------------------------------>
                  <div
                    nxLayout="grid nogutters"
                    class="padding_16 criteria_column std-mg-top-2m"
                  >
                    @if (clubData.nextRank) {
                      <div nxRow class="justify_content_center">
                        <div class="badge_column">
                          @for (
                            criteria of clubData.nextRank.criteriaList;
                            track criteria
                          ) {
                            <div class="campaign_badge">
                              <div class="justify_content_left">
                                <img
                                  [src]="
                                    'data:' +
                                    getImageType(
                                      clubData.nextRank?.badgeFilename
                                    ) +
                                    ';base64,' +
                                    clubData.nextRank?.badgeBase64
                                  "
                                  class="big_badge"
                                />
                                <div style="margin-left: 12px">
                                  @if (!isGCRCatgeory(criteria.category)) {
                                    <p nxCopytext="normal" class="primary_blue">
                                      <b>{{
                                        getCriteriaCategoryDescp(
                                          criteria.category
                                        )
                                      }}</b>
                                    </p>
                                    <p nxCopytext="normal">
                                      {{ getCriteriaTarget(criteria) }}
                                    </p>
                                    @if (!criteria.isAchieved) {
                                      <p nxCopytext="normal" class="amount">
                                        {{
                                          getCriteriaValueBasedOnCategory(
                                            criteria
                                          )
                                        }}
                                      </p>
                                      <p nxCopytext="normal">
                                        to reach
                                        <span
                                          class="primary_blue nx-font-weight-bold"
                                          ><b>next status</b></span
                                        >
                                      </p>
                                    }
                                  }
                                  @if (isGCRCatgeory(criteria.category)) {
                                    <p nxCopytext="normal" class="primary_blue">
                                      <b>{{
                                        getCriteriaCategoryDescp(
                                          criteria.category
                                        )
                                      }}</b>
                                    </p>
                                    <p nxCopytext="normal">
                                      {{
                                        getCriteriaValueDescp(
                                          criteria.valueCondition
                                        )
                                      }}
                                    </p>
                                    <p nxCopytext="normal" class="amount">
                                      {{
                                        getGCRValueBasedOnCondition(criteria)
                                      }}
                                    </p>
                                  }
                                </div>
                              </div>
                            </div>
                            <div
                              class="std-ta-center"
                              class="text_lowercase campaign_condition"
                            >
                              {{ criteria.reqCondition }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (clubData.currentRank) {
                      <div nxRow class="std-mg-top-2m">
                        <div nxCol="12" class="reward_box">
                          <div>
                            <nx-badge class="rewards">
                              <nx-icon
                                name="check"
                                size="s"
                                class="nx-margin-right-2xs"
                              ></nx-icon
                              >Unlocked
                            </nx-badge>
                          </div>
                          <h4
                            nxHeadline="subsection-xsmall"
                            class="nx-font-weight-bold m_padding_top_10"
                          >
                            &nbsp; {{ clubData.currentRank?.rewards }}
                          </h4>
                        </div>
                      </div>
                    }
                  </div>
                </nx-card>
              </div>
            </div>
          }
        </div>
      </nx-card>
    }
  </div>
  <hr class="nx-margin-y-2m" />
</div>
<!-- Medium & Small Device (Mobile & Tab) Source code -->
<div
  class="campaign nx-display-m-horizontal nx-hidden-l nx-hidden-xl nx-hidden-2xl nx-hidden-3xl"
>
  <div
    nxLayout="grid nopadding"
    class="std-mg-top-2m mobile_campaign padding_0"
  >
    <div nxRow>
      <div nxCol="12">
        <nx-accordion variant="light">
          <nx-expansion-panel class="club_member" [expanded]="index === 0">
            <nx-expansion-panel-header>
              <nx-expansion-panel-title>
                <div class="justify_content_left club_icon">
                  <img
                    src="assets/images/shared/campaign/club-icon.svg"
                    class="nx-margin-right-s"
                  />
                  <h3
                    nxHeadline="subsection-xsmall"
                    class="nx-font-weight-bold std-mg-left-2xs club_title"
                  >
                    {{ clubData.campaignName }}
                  </h3>
                </div>
              </nx-expansion-panel-title>
            </nx-expansion-panel-header>
            @if (clubData.hasError) {
              <div nxRow rowJustify="center">
                <p class="empty-campaign-text">
                  The Campaign is unavailable. Please contact your servicing
                  branch
                </p>
              </div>
            }
            @if (!clubData.hasError) {
              <div
                class="scroll-container std-mg-top-2m"
                style="overflow-x: auto"
              >
                <table
                  nxTable
                  class="nx-table--scrollable"
                  class="badge_scroll"
                  role="presentation"
                >
                  <tbody>
                    <tr nxTableRow>
                      <td nxTableCell>
                        <div class="ranks_container customized-stepper">
                          <app-custom-stepper
                            #stepper2
                            [dataList]="tempCampaignRankData"
                            class="stepper img_container"
                          ></app-custom-stepper>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <nx-card class="campaign_boxes">
                <div nxLayout="grid nopadding">
                  @if (clubData.isCompleted) {
                    <div nxRow rowAlignItems="center">
                      <div nxCol="12">
                        <nx-card class="criteria_box">
                          <div nxLayout="grid">
                            <div nxRow>
                              <div nxCol="12" class="justify_content_center">
                                <img
                                  [src]="
                                    'data:' +
                                    getImageType(
                                      clubData.currentRank?.badgeFilename
                                    ) +
                                    ';base64,' +
                                    clubData.currentRank?.badgeBase64
                                  "
                                  class="success_icon"
                                />
                              </div>
                              <div nxCol="12" class="std-mg-top-2m">
                                <h3
                                  nxHeadline="subsection-large"
                                  class="std-ta-center"
                                >
                                  {{ getCongratulatoryMessage(clubData) }}
                                </h3>
                              </div>
                            </div>
                          </div>
                          <div class="reward_box std-mg-top-2m">
                            <div>
                              <nx-badge class="rewards">
                                <nx-icon
                                  name="check"
                                  size="s"
                                  class="nx-margin-right-2xs"
                                ></nx-icon
                                >Unlocked
                              </nx-badge>
                            </div>
                            <h4
                              nxHeadline="subsection-xsmall"
                              class="nx-font-weight-bold"
                            >
                              {{ clubData.currentRank?.rewards }}
                            </h4>
                          </div>
                        </nx-card>
                      </div>
                    </div>
                  }
                  @if (!clubData.isCompleted) {
                    <div nxRow>
                      <div nxCol="12" class="justify_content_left">
                        @if (clubData.currentRank) {
                          <div style="margin-right: 16px">
                            <img
                              [src]="
                                'data:' +
                                getImageType(
                                  clubData.currentRank.badgeFilename
                                ) +
                                ';base64,' +
                                clubData.currentRank.badgeBase64
                              "
                              class="sub_header_badge"
                            />
                          </div>
                        }
                        @if (clubData.currentRank) {
                          <div class="sub_header_status">
                            <h4
                              nxHeadline="subsection-xsmall"
                              class="nx-font-weight-bold nx-margin-0"
                              style="margin-bottom: 8px !important"
                            >
                              Current Status
                            </h4>
                            <h4
                              nxHeadline="subsection-small"
                              class="primary_blue"
                              style="margin-bottom: 6px"
                            >
                              <b>{{ clubData.currentRank?.name }}</b>
                            </h4>
                            <p
                              nxCopytext="normal"
                              class="grey nx-margin-top-2xs"
                            >
                              {{
                                formatDate(clubData?.startDate, "DD/MM/YYYY")
                              }}
                              -
                              {{ formatDate(clubData?.endDate, "DD/MM/YYYY") }}
                            </p>
                            @if (clubData.currentRank) {
                              <div
                                nxRow
                                class="std-mg-top-s nx-hidden-s nx-hidden-xs"
                              >
                                <div nxCol="12">
                                  <div class="justify_content_between">
                                    @if (clubData.currentRank) {
                                      <div>
                                        {{ clubData.currentRank.name }}
                                      </div>
                                    }
                                    @if (clubData.nextRank) {
                                      <div class="break_word">
                                        {{ clubData.nextRank.name }}
                                      </div>
                                    }
                                  </div>
                                  <nx-progressbar
                                    [value]="
                                      calculateRankPercentage(
                                        clubData.currentRank.progressPercentage
                                      )
                                    "
                                    class="nx-margin-top-3xs"
                                  ></nx-progressbar>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      @if (!clubData.currentRank) {
                        <div nxCol="12" class="m_margin_left_2xs std-ta-left">
                          <p nxCopytext="normal" class="grey nx-margin-top-2xs">
                            {{ formatDate(clubData?.startDate, "DD/MM/YYYY") }}
                            -
                            {{ formatDate(clubData?.endDate, "DD/MM/YYYY") }}
                          </p>
                          <div
                            nxRow
                            class="std-mg-top-s nx-hidden-s nx-hidden-xs"
                          >
                            <div nxCol="12">
                              <div class="justify_content_between">
                                <div>
                                  {{ clubData.currentRank?.name }}
                                </div>
                                <div class="break_word">
                                  {{ clubData.nextRank?.name }}
                                </div>
                              </div>
                              <nx-progressbar
                                [value]="
                                  calculateRankPercentage(
                                    clubData.nextRank?.progressPercentage
                                  )
                                "
                                class="nx-margin-top-3xs"
                              ></nx-progressbar>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                    <div
                      nxRow
                      class="std-mg-top-s nx-hidden-m nx-hidden-m-horizontal"
                    >
                      <div nxCol="12">
                        <div class="justify_content_between">
                          <div>{{ clubData.currentRank?.name }}</div>
                          <div class="break_word">
                            {{ clubData.nextRank?.name }}
                          </div>
                        </div>
                        <nx-progressbar
                          [value]="
                            calculateRankPercentage(
                              clubData.currentRank
                                ? clubData.currentRank.progressPercentage
                                : clubData.nextRank?.progressPercentage
                            )
                          "
                          class="nx-margin-top-3xs"
                        ></nx-progressbar>
                      </div>
                    </div>
                    <div nxRow rowAlignItems="center" class="std-mg-top-2m">
                      <div nxCol="12">
                        <nx-card class="criteria_box">
                          <div class="more_info">
                            <div class="status">
                              <h4
                                nxHeadline="subsection-xsmall"
                                class="nx-font-weight-semibold no_white_space"
                              >
                                Next Status &nbsp;
                              </h4>
                              <h4
                                nxHeadline="subsection-small"
                                class="nx-font-weight-bold primary_blue break_word"
                              >
                                <b>{{ clubData.nextRank?.name }}</b>
                              </h4>
                            </div>
                            @if (clubData.nextRank?.info) {
                              <div class="justify_content_center grey">
                                <p
                                  nxCopytext="normal"
                                  (click)="openFromTemplate()"
                                  class="no_white_space"
                                >
                                  More Info
                                </p>
                                <nx-icon
                                  name="chevron-right"
                                  size="s"
                                ></nx-icon>
                              </div>
                            }
                            <ng-template #template>
                              <div class="std-ta-center campaign">
                                <img
                                  [src]="
                                    'data:' +
                                    getImageType(
                                      clubData.nextRank.badgeFilename
                                    ) +
                                    ';base64,' +
                                    clubData.nextRank.badgeBase64
                                  "
                                  class="big_badge"
                                />
                                <h3
                                  nxHeadline="subsection-medium"
                                  class="nx-margin-top-m"
                                >
                                  {{ clubData.nextRank.name }}
                                </h3>
                                <p
                                  nxCopytext
                                  class="nx-margin-top-m nx-font-weight-light"
                                >
                                  {{ clubData.nextRank.info }}
                                </p>
                              </div>
                              <div class="std-ta-center">
                                <button
                                  nxModalClose
                                  nxButton="secondary"
                                  (click)="closeTemplateDialog()"
                                  class="std-mg-top-2m"
                                >
                                  CLOSE
                                </button>
                              </div>
                            </ng-template>
                          </div>
                          <!--------------------change code------------------>
                          <div nxLayout="grid nogutters" class="std-mg-top-2m">
                            @if (clubData.nextRank) {
                              <ng-container style="align-items: center">
                                <div nxRow class="justify_content_center">
                                  <div class="badge_column">
                                    @for (
                                      criteria of clubData.nextRank
                                        .criteriaList;
                                      track criteria
                                    ) {
                                      <div class="campaign_badge">
                                        <img
                                          [src]="
                                            'data:' +
                                            getImageType(
                                              clubData.nextRank?.badgeFilename
                                            ) +
                                            ';base64,' +
                                            clubData.nextRank?.badgeBase64
                                          "
                                          class="big_badge"
                                        />
                                        @if (
                                          !isGCRCatgeory(criteria.category)
                                        ) {
                                          <p
                                            nxCopytext="normal"
                                            class="primary_blue nx-font-weight-bold"
                                          >
                                            <b>{{
                                              getCriteriaCategoryDescp(
                                                criteria.category
                                              )
                                            }}</b>
                                          </p>
                                          <p nxCopytext="normal">
                                            {{ getCriteriaTarget(criteria) }}
                                          </p>
                                          @if (!criteria.isAchieved) {
                                            <p
                                              nxCopytext="normal"
                                              class="amount"
                                            >
                                              {{
                                                getCriteriaValueBasedOnCategory(
                                                  criteria
                                                )
                                              }}
                                            </p>
                                            <p nxCopytext="normal">
                                              to reach
                                              <span
                                                class="primary_blue nx-font-weight-bold"
                                                ><b>next status</b></span
                                              >
                                            </p>
                                          }
                                        }
                                        @if (isGCRCatgeory(criteria.category)) {
                                          <p
                                            nxCopytext="normal"
                                            class="primary_blue nx-font-weight-bold"
                                          >
                                            <b>{{
                                              getCriteriaCategoryDescp(
                                                criteria.category
                                              )
                                            }}</b>
                                          </p>
                                          <p nxCopytext="normal">
                                            {{
                                              getCriteriaValueDescp(
                                                criteria.valueCondition
                                              )
                                            }}
                                          </p>
                                          <p nxCopytext="normal" class="amount">
                                            {{
                                              getGCRValueBasedOnCondition(
                                                criteria
                                              )
                                            }}
                                          </p>
                                        }
                                      </div>
                                      <div
                                        class="std-ta-center"
                                        class="text_lowercase campaign_condition"
                                      >
                                        {{ criteria.reqCondition }}
                                      </div>
                                    }
                                  </div>
                                </div>
                              </ng-container>
                            }
                            @if (clubData.currentRank) {
                              <div class="reward_box std-mg-top-2m">
                                <div>
                                  <nx-badge class="rewards">
                                    <nx-icon name="check" size="s"></nx-icon>
                                    Unlocked
                                  </nx-badge>
                                </div>
                                <h4
                                  nxHeadline="subsection-xsmall"
                                  class="nx-font-weight-bold m_padding_top_10"
                                >
                                  {{ clubData.currentRank?.rewards }}
                                </h4>
                              </div>
                            }
                          </div>
                        </nx-card>
                      </div>
                    </div>
                  }
                </div>
              </nx-card>
            }
          </nx-expansion-panel>
        </nx-accordion>
      </div>
    </div>
  </div>
</div>
